import * as tslib_1 from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { API_URL } from "../../config/urls";
import axios from "axios";
var QuizResults = /** @class */ (function (_super) {
    tslib_1.__extends(QuizResults, _super);
    function QuizResults(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            quiz: null,
            results: [],
            total: 0,
            loading: false,
        };
        return _this;
    }
    QuizResults.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({ loading: true });
        axios.get(API_URL + "/quiz/results/" + this.props.match.params.id).then(function (r) {
            if (r.data && r.data.data) {
                axios.get(API_URL + "/quiz/" + _this.props.match.params.id).then(function (resp) {
                    if (resp.data && resp.data.data && resp.data.code === 200) {
                        _this.setState({ quiz: resp.data.data, results: r.data.data, total: r.data.meta.total, loading: false });
                    }
                    else {
                        _this.setState({ results: r.data.data, total: r.data.meta.total, loading: false });
                    }
                }).catch(function (e) {
                    console.log(e);
                });
            }
            else {
                _this.setState({ loading: false });
            }
        }).catch(function (e) {
            console.log(e);
            _this.setState({ loading: false });
        });
    };
    QuizResults.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return (React.createElement("div", null, "\u0418\u0434\u0451\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432. \u041E\u0436\u0438\u0434\u0430\u0439\u0442\u0435..."));
        }
        if (!this.state.quiz) {
            return (React.createElement("div", null, "\u0413\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"));
        }
        var params = (typeof this.state.quiz.params === 'string') ? JSON.parse(this.state.quiz.params) : this.state.quiz.params;
        var titles = {};
        params.questions.forEach(function (q, qi) {
            q.answers.forEach(function (a, ai) {
                titles[a.guid] = q.guid;
            });
        });
        console.log(titles);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { display: 'inline-block' } },
                React.createElement("a", { href: API_URL + "/quiz/results/excel-users/" + this.props.match.params.id + "?token=" + this.props.auth_token, target: "_blank", type: 'button', className: 'btn btn-success btn-search' }, "EXCEL \u0412\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C")),
            React.createElement("div", { style: { display: 'inline-block' } },
                React.createElement("a", { href: API_URL + "/quiz/results/excel/" + this.props.match.params.id + "?token=" + this.props.auth_token, target: "_blank", type: 'button', className: 'btn btn-warning btn-search' }, "EXCEL \u0412\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0435")),
            React.createElement("div", { className: "m-widget24" },
                React.createElement("div", { className: "m-widget24__item" },
                    React.createElement("h4", { className: "m-widget24__title" },
                        "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u044F \u2116",
                        this.props.match.params.id),
                    React.createElement("br", null),
                    React.createElement("span", { className: "m-widget24__desc" }, "\u0412\u0441\u0435\u0433\u043E \u043F\u0440\u043E\u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043B\u043E"),
                    React.createElement("span", { className: "m-widget24__stats m--font-brand" }, this.state.total),
                    React.createElement("div", { className: "m--space-10" }),
                    (params.questions && params.questions.length > 0) && params.questions.map(function (q, qIdx) { return (React.createElement(React.Fragment, { key: 'question-' + qIdx },
                        React.createElement("div", { className: "m-portlet m-portlet--brand m-portlet--head-solid-bg m-portlet--bordered" },
                            React.createElement("div", { className: "m-portlet__head" },
                                React.createElement("div", { className: "m-portlet__head-caption" },
                                    React.createElement("div", { className: "m-portlet__head-title" },
                                        React.createElement("h3", { className: "m-portlet__head-text" },
                                            "\u0412\u043E\u043F\u0440\u043E\u0441 ",
                                            qIdx + 1,
                                            " : ",
                                            q.title))))),
                        React.createElement("div", { className: "m-portlet__body" }, _this.state.results.map(function (res, idx) { return (React.createElement(React.Fragment, { key: 'r-' + idx }, titles[res.guid] === q.guid && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "progress m-progress--sm" },
                                React.createElement("div", { className: "progress-bar m--bg-brand", role: "progressbar", style: { width: (Math.round(res.count / _this.state.total * 100)).toString() + "%" } })),
                            React.createElement("span", { className: "m-widget24__change" },
                                res.title,
                                " - ",
                                res.count),
                            React.createElement("span", { className: "m-widget24__number" },
                                _this.state.total > 0 ? Math.round(res.count / _this.state.total * 100) : 0,
                                "%"))))); })))); })))));
    };
    return QuizResults;
}(React.Component));
export default withRouter(connect(function (state) { return ({
    auth_token: state.app.get("auth_token"),
}); })(QuizResults));



//////////////////
// WEBPACK FOOTER
// ./src/views/quizzes/results.tsx
// module id = 541
// module chunks = 0